import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const containerStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    alignItems: "start",
    backgroundColor: "colorBackgroundPrimary",
    padding: "space20",
    paddingTop: "space40",
    paddingBottom: "space40",
    borderTopLeftRadius: "borderRadius20",
    borderTopRightRadius: "borderRadius20",
};

export const titleStyles: TextStyleProps = {
    color: "colorTextWeakest",
    paddingLeft: "space30",
    fontWeight: "fontWeightSemibold"
};

export const subTitleStyles: TextStyleProps = {
    color: "colorTextWeakest",
    paddingLeft: "space30",
    fontWeight: "fontWeightLight",
    fontSize: "fontSize20"
}